import { createAction } from '@reduxjs/toolkit';

export const SET_GLOBAL_ERROR = 'global/SET_GLOBAL_ERROR';

export const setGlobalError = createAction<boolean | string>(SET_GLOBAL_ERROR);
